<template>
  <SmartCard
    tag="button"
    :class="[boxColor, boxBackground]"
    class="
      flex
      box-icon
      flex-col
      align-center
      pt-2
      cursor-pointer
      my-2
      cursor-pointer
      user-select-none
    "
    @click.native="action"
  >
    <SmartIcon :name="icon" :size="10" type="big" />
    <label
      class="
        mt-1
        mb-3
        inline-block
        text-center
        w-full
        font-medium
        cursor-pointer
      "
    >
      {{ label }}
    </label>
  </SmartCard>
</template>

<script>
// @flow
const avaliableColors = ['blue', 'yellow', 'light-blue', 'green', 'white', 'wine'];

export default {
  name: 'SmartIconDash',
  components: {
    SmartIcon: () => import('../SmartIcon'),
    SmartCard: () => import('../SmartCard')
  },
  props: {
    label: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: 'blue',
      validator(value: string): boolean {
        return avaliableColors.includes(value);
      }
    },
    background: {
      type: String
    },
    icon: {
      type: String,
      default: 'online'
    },
    action: {
      type: Function,
      default: () => true
    }
  },
  computed: {
    boxColor() {
      return `box-icon--${this.color}`;
    },
    boxBackground() {
      return `box-bg--${this.background}`;
    }
  }
};
</script>

<style lang="scss">
.box-icon {
  box-shadow: 0px 4px 12px rgba($color-ui-black, $opacity-low-min);
  border-radius: $border-radius-default;
  transition-property: opacity, border-color, box-shadow, transform;
  transition-duration: $transition-sm-slow;
  transition-timing-function: $transition-easing-default;
  &:hover {
    opacity: 0.9;
    transform: scale(1.05);
  }
  &:focus {
    outline: none;
  }
  &:active,
  &:focus {
    @extend .box-icon:hover;
    opacity: 0.8;
    box-shadow: 0 2px 24px rgba($color-ui-black, $opacity-low-max);
  }
  &--blue {
    color: $color-brand-primary;
  }
  &--yellow {
    color: $color-ui-warning;
  }
  &--light-blue {
    color: $color-ui-accent;
  }
  &--green {
    color: $color-brand-secondary;
  }
  &--white {
    color: $color-ui-white;
  }
}
.box-bg {
  &--green {
    background: linear-gradient(171.67deg, #66bb6a 4.89%, #5acb6c 88.08%);
  }
  &--purple {
    background: linear-gradient(180deg, #721cb6 0%, #9922d1 100%);
  }
  &--light-blue {
    background: linear-gradient(334.33deg, #2bb2ff 0%, #3766c2 98.41%);
  }
  &--goals-blue {
    background: linear-gradient(334.33deg, #4169e1 0%, #3766c2 98.41%);
  }
  &--orange {
    background: linear-gradient(180deg, #ff825a 0%, #fe754a 100%);
  }
  &--blue {
    background: linear-gradient(180deg, #022d8e 0%, #3252bd 100%);
  }
  &--yellow {
    background: linear-gradient(334.33deg, #fab932 0%, #fada97 98.41%);
  }
  &--dark-blue {
    background: linear-gradient(180deg, #095773 0%, #1382ab 100%);
  }
  &--water-green {
    background: linear-gradient(180deg, #0ac2c2 0%, #1aa0a0 100%);
  }
  &--wine {
    background: #642d5f;
  }
}
</style>
